import { render, staticRenderFns } from "./OrdersNew.vue?vue&type=template&id=240afd88&scoped=true&"
import script from "./OrdersNew.vue?vue&type=script&lang=js&"
export * from "./OrdersNew.vue?vue&type=script&lang=js&"
import style0 from "./OrdersNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrdersNew.vue?vue&type=style&index=1&id=240afd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240afd88",
  null
  
)

export default component.exports